import { poppins } from "@/components/common/fonts";
import { Button, Modal } from "antd";
import Image from "next/image";
import styled from "styled-components";

export const StyledPlanSwitchModal = styled(Modal)`
  .ant-modal-content {
    background: linear-gradient(78.95deg, #22b086 0.16%, #0044cc 105.8%);
    height: 580px;
    padding: 0px;

    .ant-modal-close {
      color: white;
    }

    :global(.ant-modal-body) {
      height: 440px;
    }

    .ant-modal-footer {
      margin-top: 0px;
    }

    .more-section {
      background-color: #4276ee;
      height: 160px;
      border-bottom-left-radius: 7px;
      border-bottom-right-radius: 7px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      gap: 14px;

      .message {
        font-family: ${poppins.string};
        font-weight: 600;
        font-size: 20px;
        line-height: 20px;
        color: white;
      }
    }
  }
`;

export const StyledLeadMoreButton = styled(Button)`
  border: 2px solid #c9d9ff;
  box-shadow: 0px 2px 10px 0px #1d58e1;
  width: 300px;
  height: 48px;
  background-color: #1452df;
`;

export const StyledPersonalImage = styled(Image)`
  object-fit: contain;
  /* margin-top: auto; */
`;

export const ModalRootDiv = styled.div`
  height: 100%;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 420px;

  .slide {
    display: flex;
    flex-direction: column;
    align-items: center;

    .team-step2 {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .headline {
        font-family: ${poppins.string};

        .header {
          background-color: white;
          border-radius: 20px;
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          padding: 2px 15px;
        }

        .title {
          margin-top: 20px;
          /* margin-bottom: 10px; */
          font-size: 28px;
          font-weight: 600;
          line-height: 42px;
          color: white;
        }
      }

      .sub-txt {
        bottom: 20px;
        right: 10px;
        position: absolute;
        color: white;
        font-family: ${poppins.string};
        font-size: 12px;
        font-weight: 300;
        line-height: 18px;
      }
    }
  }

  .dots {
    position: absolute;
    bottom: 5px;
    display: flex;
    justify-content: center;
    z-index: 10;
    .dot {
      width: 10px;
      height: 10px;
      margin: 0 6px;
      border-radius: 50%;
      border: none;
      background-color: #ccc;
      cursor: pointer;
      transition: background-color 0.3s ease;
    }
    .activeDots {
      background-color: #4276ee;
    }
  }
`;
